<template>
	<div>
		<div style="margin-bottom: 18px;margin-top: 18px;">
			<label style="color: #333333;margin-left: 20px;">名称：</label>
			<el-input v-model="name" placeholder="请输入名称" suffix-icon="el-icon-search" style="width: 200px;" size="small"
				@keyup.enter.native="getData"></el-input>

			<el-button type="primary" style="margin-left: 15px;" size="small" @click="getData">查询</el-button>
			<el-button type="success" style="margin-left: 15px;" size="small" @click="reset">重置</el-button>
			<el-button type="warning" style="margin-left: 15px;" size="small" @click="add">新增</el-button>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border
			highlight-current-row>
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="title" align="center" label="名称(中文)" width="180">
			</el-table-column>
			<el-table-column prop="titleEg" align="center" label="名称(英文)" width="180">
			</el-table-column>
			<el-table-column prop="content" align="center" label="详情(中文)">
			</el-table-column>
			<el-table-column prop="contentEg" align="center" label="详情(英文)">
			</el-table-column>

			<el-table-column prop="operate" align="center" label="操作" width="200">
				<template slot-scope="scope">
					<el-button type="success" size="small" @click="mod(scope.row,1)">编辑</el-button>
					<el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row)" style="margin-left: 10px;">
						<el-button type="danger" slot="reference" size="small">删除</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>

		<div style="align-content: center;text-align: center;margin: 20px;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				:page-sizes="[2, 5, 10, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible" width="50%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="100px">

				<el-form-item label="类型" prop="type">
					<el-select v-model="form.type" placeholder="请选择" @change="selectChange">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <label style="color: #333333;margin-left: 20px;">类型：</label> -->

				<el-form-item label="子类型" prop="type1" v-show="isShow2">
					<el-select v-model="form.type1" placeholder="请选择">
						<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <label style="color: #333333;margin-left: 20px;" v-show="isShow2">子类型：</label>
				<el-select v-model="form.type1" placeholder="请选择" v-show="isShow2" style="margin-left: 40px;">
					<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select> -->

				<el-form-item label="名称(中文)" prop="title" style="margin-top: 20px;">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.name"></el-input> -->
						<tinymce-editor v-model="form.title" :init="initEditor" />
					</el-col>
				</el-form-item>
				<el-form-item label="名称(英文)" prop="titleEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.nameEg"></el-input> -->
						<tinymce-editor v-model="form.titleEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容(中文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.firstTitle" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.content" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="内容(英文)" prop="contentEg">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.firstTitleEg" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.contentEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<label style="color: #333333;margin-left: 20px;margin-top: 20px;" v-show="isShow">产品：</label>
				<el-select v-model="form.list" filterable multiple placeholder="请选择" style="margin-left: 40px;"
					v-show="isShow">
					<el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>

			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	export default {
		name: "UserMange",
		components: {
			TinymceEditor
		},
		data() {
			return {
				options: [{
					value: '1',
					label: '行业应用'
				}, {
					value: '2',
					label: '产品'
				}, {
					value: '3',
					label: '大事记'
				}],
				options2: [{
					value: '1',
					label: '风力发电'
				}, {
					value: '2',
					label: '矿山'
				}, {
					value: '3',
					label: '轨道交通'
				}, {
					value: '4',
					label: '悬索桥'
				}],
				options1: [],
				type: 1,
				rules: {
					name: [{
						required: true,
						message: '请输入名字',
						trigger: 'blur'
					}]
				},
				tableData: [],
				pageSize: 10,
				page: 1,
				total: 0,
				name: "",
				type: "",
				centerDialogVisible: false,
				form: {
					id: "",
					title: "",
					titleEg: "",
					content: "",
					contentEg: "",
					list: "",
					type: "",
					type1: ""
				},
				btnText: "提 交",
				textTitle: "新增信息",
				isDis: false,
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				fileList: [],
				fileList1: [],
				imageUrl: '',
				imgType: 0,
				fullscreenLoading: false,
				isShow: false,
				isShow2: false

			}
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},
		beforeMount() {
			// this.utils.Logger("1111111111111111");
			this.getData();
			this.getType();
			// this.loadPost();
		},
		methods: {
			selectChange(e) {
				if (e == "1") {
					this.getDataProduct("1");
					this.isShow2 = true;
				} else if (e == "2") {
					this.getDataProduct("2");
					this.isShow2 = false;
				} else {
					that.isShow = false;
					this.isShow2 = false;
				}
			},
			getDataProduct(type) {
				var that = this;
				var params = {
					"pageSize": 1000,
					"pageNum": 1,
					"param": {
						// "type":type
					}
				};
				this.utils.requestPost(this, "/goods/getDataList", params, function(res, total) {
					that.options1 = [];
					for (var i = 0; i < res.length; i++) {
						var bean = res[i];
						that.options1.push({
							value: bean.id,
							label: bean.name
						});

					}
					that.isShow = true;
				})
			},
			mod(row, type) {
				this.form = row;
				this.imgType = type;
				this.btnText = "保存";
				this.textTitle = '修改信息'
				this.centerDialogVisible = true;
				if (row.type == 1) {
					this.isShow = true;
					this.isShow1 = true;
					this.getDataProduct();
					this.form.list = this.form.list != "" ? this.form.list.split(",") : "";
					for (var i = 0; i < this.form.list.length; i++) {
						this.form.list[i] = parseInt(this.form.list[i]);
					}
				} else if (row.type == 2) {
					this.isShow = true;
					this.form.list = this.form.list != "" ? this.form.list.split(",") : "";
					for (var i = 0; i < this.form.list.length; i++) {
						this.form.list[i] = parseInt(this.form.list[i]);
					}
					this.getDataProduct();
				}
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			save() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (that.btnText == "提交") {
							this.form.list = this.form.list != "" ? this.form.list.join(",") : "";
							this.utils.requestPost(this, "/allHomeSubList/add", this.form, function(
								res,
								total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "创建成功");
							});
						} else {
							this.form.list = this.form.list != "" ? this.form.list.join(",") : "";
							this.utils.requestPost(this, "/allHomeSubList/mod", this.form, function(
								res,
								total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "修改成功");
							});
						}
					} else {
						that.utils.showMessage("error", "请输入正确的内容");
						return false;
					}
				});

			},
			add() {
				var that = this;
				this.btnText = "提交";
				this.textTitle = '添加信息'
				this.imgType = 1;
				this.form = {
					id: "",
					title: "",
					titleEg: "",
					content: "",
					contentEg: "",
					list: "",
					type: "",
					type1: ""
				};
				this.isShow = false;
				this.isShow2 = false;
				this.centerDialogVisible = true;
				this.$nextTick(() => {
					that.resetForm();
				})
			},
			reset() {
				this.name = "";
				this.type = "";
			},
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
			deleteRow(row) {
				var that = this;
				this.utils.requestPost(this, "/allHomeSubList/delete", row, function(res, total) {
					that.getData();
					that.utils.showMessage("success", "删除成功");
				});
			},
			getData() {
				var that = this;
				if (this.type != "")
					this.type = parseInt(this.type)
				else
					this.type = 0;

				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.name,
						"type": parseInt(this.type)
					}
				};
				this.utils.requestPost(this, "/allHomeSubList/getDataList", params, function(res, total) {
					that.tableData = res;
					that.total = total;
				});
			},
			getType() {
				var that = this;
				if (this.type != "")
					this.type = parseInt(this.type)
				else
					this.type = 0;

				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.name
					}
				};
				this.utils.requestPost(this, "/typeList/getDataList", params, function(res, total) {
					that.options2 = res;
				});
			}
		}


	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
